export const DIET_STATUS_DROPDOWN_DEFAULT = "all";

// "All" leads, since it is the default selection and the filters read as a
// chip row rather than a dropdown.
export const DIET_STATUS_DROPDOWN = [
  { label: "All", value: "all" },
  { label: "Pending", value: "pending" },
  { label: "Approved", value: "approved" },
  { label: "Drafts", value: "draft" },
  { label: "Rejected", value: "rejected" },
  { label: "Inactive", value: "inactive" },
];

export const DIET_STATUS = {
  PUBLISHED: "published",
  REJECTED: "rejected",
  APPROVED: "approved",
  DRAFT: "draft",
  PENDING: "pending",
  INACTIVE: "inactive",
};

export const INDIAN_CUISINES = [
  "north_indian",
  "south_indian",
  "gujarati",
  "maharashtrian",
  "bengali",
  "rajasthani",
  "punjabi",
  "tamil",
  "kerala",
  "andhra",
  "kashmiri",
  "goan",
];

export const COMMON_DIETARY_RESTRICTIONS = [
  "low fat",
  "low fat diet",
  "high fiber diet",
  "low sugar",
  "low sodium",
  "gluten free",
  "dairy free",
  "nut free",
  "low carb",
  "keto friendly",
  "diabetic friendly",
  "heart healthy",
  "high protein",
];

export const NUTRIENT_MESSAGE = {
  FAT_INFO: `<b>The "Fat goal" in grams is calculated as follows:</b>
  <span style="font-weight: 900;">&#x2022;</span> Convert the fat percentage to fat calories based on the total calories.
  <span style="font-weight: 900;">&#x2022;</span> Divide the fat calories by 9 to convert them into grams.

<b>"Actual Fat" represents:</b>
  <span style="font-weight: 900;">&#x2022;</span> The total of the average fats from each meal's options.`,

  PROTEIN_INFO: `<b>The "Protein goal" in grams is calculated as follows:</b>
  <span style="font-weight: 900;">&#x2022;</span> Convert the protein percentage to protein calories based on the total calories.
  <span style="font-weight: 900;">&#x2022;</span> Divide the protein calories by 4 to convert them into grams.

<b>"Actual Protein" represents:</b>
  <span style="font-weight: 900;">&#x2022;</span> The total of the average proteins from each meal's options.`,

  CARBS_INFO: `<b>The "Carbs goal" in grams is calculated as follows:</b>
  <span style="font-weight: 900;">&#x2022;</span> Convert the carbs percentage to carbs calories based on the total calories.
  <span style="font-weight: 900;">&#x2022;</span> Divide the carbs calories by 4 to convert them into grams.

<b>"Actual Carbs" represents:</b>
  <span style="font-weight: 900;">&#x2022;</span> The total of the average carbs from each meal's options.`,
};

export const DIET_PLAN_PDF_NUTRITION_TIPS = [
  "Utilize unrefined oils, such as cold-pressed extra virgin coconut, rice bran, sesame, groundnut, and mustard oil, limiting intake to 3-4 teaspoons daily, along with 1 teaspoon of desi ghee.",
  "Opt for rock salt or Himalayan pink salt in cooking, minimizing overall salt intake. Reduce fatty and fried foods, as well as spicy and salty items like french fries, chips, papads, and pickles.",
  "For effective weight loss, restrict daily sugar intake.",
  "Limit consumption of bakery products, avoiding biscuits, toast, pav, white bread, and khari due to their trans fat, saturated fat, and baking soda content, which may be harmful to the liver and heart.",
  "Embrace turmeric, garlic, onions, ginger, sesame seeds, black pepper, cinnamon, and cooked tomatoes in meal preparations for their health benefits.",
  "Aim for 10-12 glasses of water per day.",
  "Consume salads or soups before your main course to promote a sense of partial fullness.",
];

export const DIET_PLAN_PDF_MINDFUL_EATING_TIPS = [
  "Maintain a gap of minimum 3 to 3.5 hours between any meals",
  "Maintain a gap of 3 hours between last meal of the day and bedtime to prevent acidity and heartburn.",
  "Have early dinner, preferably before 8:30 pm.",
  "Practice mindful eating by chewing food thoroughly, eating slowly for at least 20 minutes, place your spoon/fork on table after every bite, take deep breaths, enjoy what you are eating. Stop when full.",
];

export const DIET_PLAN_PDF_LIFESTYLE_TIPS = [
  "Prioritize 7-8 hours of sleep, incorporating 5-10 minutes of deep breathing before bedtime. Oxygen intake helps suppress cortisol, promoting better sleep. Sleep is crucial for healing, growth, and detoxification.",
  "Make time for your hobbies. It helps to improve your overall mood & mental health.",
  "Keep yourself active by indulging in some sort of physical activity like yoga, walking, swimming, aerobics etc",
];

export const DIET_PLAN_PDF_COPY = {
  NUTRITION_TIPS_TITLE: "Nutrition Tips:",
  MINDFUL_EATING_TIPS_TITLE: "Mindful Eating Tips:",
  LIFESTYLE_TIPS_TITLE: "Other lifestyle:",
  KITCHEN_MEASUREMENTS_TITLE: "Kitchen Measurements:",
  DISCLAIMER_TITLE: "Disclaimer:",
  IMPORTANT_NOTE_TITLE: "Important Note:",
  DISCLAIMER:
    "The diet plan offered is tailored solely for the individual patient based on the information provided and their unique clinical condition. It is strictly confidential and not intended for sharing or application to anyone else. These are general tips, which we can share at the bottom of every diet plan.",
  IMPORTANT_NOTE:
    "Please adhere to the specified portions and meal combinations outlined in the diet plan. If you have any inquiries regarding the diet plan, please feel free to reach out to your health coach. If you are not comfortable with the provided diet plan and need some variations or adjustments, kindly contact your diet coach for assistance.",
  IMPORTANT_NOTE_OCCASIONS:
    "Inform your coach in advance about any planned occasions where you might be eating outside, such as weddings or birthdays. This allows the coach to assist you in making healthier food choices while still enjoying the event.",
};
